module.exports = __webpack_public_path__ + "static/media/Ai.75f0fde9.yaml";